import React, { forwardRef } from "react";
import styled from "styled-components";

const Box = styled.div`
    position: relative;
    height: 32px;
    padding: 0 7.2px 0 4px;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    filter: saturate(0.5);

    &::after {
        content: "At ${(props) => props.ghostStation}";
        position: absolute;
        background: #fff;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 10px;
        border-radius: 5px;
        border: 2px solid #6a73b2;
        padding: 3px 6px;
        color: #6a73b2;
        font-weight: bold;
        white-space: nowrap;
    }
`;

const ShowGhostShiftBox = forwardRef(({ ghostStation = "" }, ref) => {
    return <Box ref={ref} ghostStation={ghostStation} />;
});

ShowGhostShiftBox.displayName = "ShowGhostShiftBox";

export default React.memo(ShowGhostShiftBox);
